/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

import "@fontsource/lato/latin.css";
import "@fontsource/cormorant/latin.css";

window.blueimp = require('blueimp-gallery');
window.slick = require('slick-carousel');

;$(function() {

    $('.gallery').each(function() {
        this.onclick = function (event) {
            event = event || window.event;
            var target = event.target || event.srcElement,
                link = target.src ? target.parentNode.parentNode : target,
                options = {index: link, event: event},
                links = this.getElementsByTagName('a');

            window.blueimp(links, options);
        };
    });

    $('section.slider .slick').slick({
        infinite: true,
        autoplay: true,
        dots: false,
        arrows: false,
        fade: true,
        speed: 1000
    });

});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 3
// module chunks = 0